export class DatosGeneral {
    nro_formulario: string;
    hora_inicio: string;
    fecha_registro: string;
    estado_formulario: string;
    flg_deshabilita = true;

}

